import { render } from "./InputFormSocial.vue?vue&type=template&id=b5b878ac"
import script from "./InputFormSocial.vue?vue&type=script&lang=ts"
export * from "./InputFormSocial.vue?vue&type=script&lang=ts"
script.render = render

export default script